import React from "react";
import skeleton from "./skeleton.css";
import {NUMBER} from "../../../constants/app-constants";

const Skeleton = () => {
    return (
        <div styleName={"skeleton.wrapper"}>
            <div className="shimmer" styleName={"skeleton.heading"} />

            <div styleName={"skeleton.skeletonCityWrap"}>
                {Array.from({ length: NUMBER.SIXTEEN }).map((_, index) => (
                    <div styleName={"skeleton.flexItem"} key={index}>
                        <div className="shimmer" styleName={"skeleton.skeletonCityIcon"} />
                        <div className="shimmer" styleName={"skeleton.skeletonCityName"} />
                    </div>
                ))}

            </div>
        </div>
    );
};

export default Skeleton;
